import { Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { SignUpCredentials } from '../../../types';
import { ApiService } from '@fan-services/api.service';
import { CaptchaComponent } from '@fan-shared/captcha/captcha.component';
import { AlertService } from '@fan-shared/alert/alert.service';

@Component({
  selector: 'register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss'],
  standalone: false,
})
export class RegisterFormComponent {
  @Output() goToLogin = new EventEmitter();
  @Output() goToVerify = new EventEmitter<string>();
  @Input() fromRoute = true;
  checked = false;
  alertService = inject(AlertService);
  @ViewChild('dashCaptcha', { static: true }) dashCaptcha!: CaptchaComponent;

  credentials: SignUpCredentials = {
    email: '',
    password: '',
    contactNumber: '',
    firstName: '',
    lastName: '',
  };

  processing = false;

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {}

  submit() {
    if (!this.checked) return;
    this.processing = true;
    this.dashCaptcha.startCaptcha();
  }

  registerUser(token: string) {
    this.apiService.user.register({ ...this.credentials }, token).subscribe({
      next: (profile) => {
        this.processing = false;
        if (profile?.id) {
          if (this.fromRoute) {
            this.router.navigate(['/verify'], { queryParams: { email: this.credentials.email } });
          } else {
            this.goToVerify.emit(this.credentials.email);
          }
        }
      },
      error: () => {
        this.processing = false;
        this.alertService.open('modal.registerError');
      },
    });
  }

  loginClick() {
    this.goToLogin.observers.length ? this.goToLogin.emit() : this.router.navigate(['/login']);
  }

  onTokenGenerated(token: string) {
    if (token) {
      this.registerUser(token);
    } else {
      this.processing = false;
    }
  }
}
